import { types } from "../types";

const TranslationAction = {
  translationAuth: (language) => {
    return { type: types.GET_TRANSLATION_CACHE, language };
  },
  translationAuthSuccess: (response) => {
    return { type: types.GET_TRANSLATION_CACHE_SUCCESS, response };
  },
};

export default TranslationAction;

export const getTranslationCache = (language) => ({
  type: types.GET_TRANSLATION_CACHE,
  language,
});
